module.exports = __webpack_public_path__ + "static/media/icon-caret-prev.32253ec8.svg";